'use client'
import React from 'react'

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
    active?: boolean
    clickable?: boolean
    subChildren?: React.ReactNode
}

export const ListItem = React.forwardRef<HTMLLIElement, ListItemProps>(
    ({ active = false, clickable = true, subChildren, children, ...props }: ListItemProps, ref) => {
        const clickableStyles = !active && clickable ? 'cursor-pointer hover:bg-interactive' : ''
        const activeStyles = active ? 'bg-interactive' : ''

        return (
            <li
                {...props}
                className={`list-item-component flex flex-col border-b border-shade-200 ${props?.className || ''}`}
                ref={ref}
            >
                <div className={`list-item-component__content ${activeStyles} ${clickableStyles}`}>{children}</div>
                {subChildren}
            </li>
        )
    },
)
